var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondiments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66693 4.66668C5.66693 5.21896 6.11465 5.66668 6.66693 5.66668H17.3336C17.8859 5.66668 18.3336 5.21896 18.3336 4.66668V2C18.3336 1.44772 17.8859 1 17.3336 1H6.66693C6.11465 1 5.66693 1.44772 5.66693 2V4.66668ZM7.66693 3.66668V3H16.3336V3.66668H7.66693Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66702 18.3333C3.66702 18.8856 4.11474 19.3333 4.66702 19.3333H19.3337C19.886 19.3333 20.3337 18.8856 20.3337 18.3333V8.66668C20.3337 8.1144 19.886 7.66668 19.3337 7.66668H4.66702C4.11474 7.66668 3.66702 8.1144 3.66702 8.66668V18.3333ZM5.66702 17.3333V9.66668H18.3337V17.3333H5.66702Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00038 21C5.91178 21 5.8274 20.9649 5.76526 20.9027L5.76444 20.9019C5.70206 20.8396 5.66702 20.7551 5.66702 20.6666V19.3333H18.3337V20.6666C18.3337 20.7552 18.2987 20.8396 18.2363 20.9018L18.2355 20.9027C18.1733 20.9649 18.089 21 18.0003 21H6.00038ZM4.35052 22.3164C4.78834 22.7546 5.38188 23 6.00038 23H18.0003C18.6188 23 19.2122 22.7546 19.65 22.3166C20.0882 21.8788 20.3337 21.2853 20.3337 20.6666V18.3333C20.3337 17.781 19.886 17.3333 19.3337 17.3333H4.66702C4.11474 17.3333 3.66702 17.781 3.66702 18.3333V20.6666C3.66702 21.2853 3.91258 21.8787 4.35052 22.3164Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74314 9.04935C3.89792 9.42303 4.26256 9.66667 4.66702 9.66667H19.3337C19.7382 9.66667 20.1028 9.42303 20.2576 9.04935C20.4124 8.67568 20.3268 8.24556 20.0408 7.95956L17.667 5.58577V4.66667C17.667 4.11438 17.2193 3.66667 16.667 3.66667H7.3337C6.78142 3.66667 6.3337 4.11438 6.3337 4.66667V5.58577L3.95991 7.95956C3.67392 8.24556 3.58836 8.67568 3.74314 9.04935ZM7.08124 7.66667L8.04081 6.70709C8.22834 6.51956 8.3337 6.2652 8.3337 5.99999V5.66667H15.667V5.99999C15.667 6.2652 15.7724 6.51956 15.9599 6.70709L16.9195 7.66667H7.08124Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondiments);
export default __webpack_public_path__ + "static/media/condiments.2ad1dd8a664621bb3920a5f192b02e8d.svg";
export { ForwardRef as ReactComponent };